import { render, staticRenderFns } from "./group-panel.vue?vue&type=template&id=99c6dd1e&scoped=true&"
import script from "./group-panel.vue?vue&type=script&lang=js&"
export * from "./group-panel.vue?vue&type=script&lang=js&"
import style0 from "./group-panel.vue?vue&type=style&index=0&id=99c6dd1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c6dd1e",
  null
  
)

export default component.exports